import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { BarChart } from '@mui/x-charts/BarChart'
import { BarSeriesType } from '@mui/x-charts'
import React from 'react'
import { formatPercentage } from '../../../packages/utils/numberFormatters'

type BarSerieWithLabel = Omit<BarSeriesType, 'type'> & { label: string }

export const CommitChart = ({ series, locale }: { series: BarSerieWithLabel[]; locale: string }) => {
    const labelSeries = series
        .reduce((acc: BarSerieWithLabel[], item: BarSerieWithLabel) => {
            const existingObjectIndex = acc.findIndex((i) => i.label === item.label)

            if (existingObjectIndex >= 0 && item.label === 'Ej säkerställt') {
                const existingObject = acc[existingObjectIndex]
                const updatedDataValue = existingObject.data[0] + item.data[0]
                acc[existingObjectIndex] = {
                    ...existingObject,
                    data: [updatedDataValue],
                }
                return acc
            }
            acc.push(item)
            return acc
        }, [])
        .sort((a, b) => {
            if (a.label === 'Ej säkerställt') return 1
            if (b.label === 'Ej säkerställt') return -1
            return 1
        })

    return (
        <Box mb={8}>
            <BarChart
                margin={{
                    left: -50,
                    right: 0,
                    top: 0,
                    bottom: 20,
                }}
                skipAnimation
                layout='horizontal'
                slotProps={{
                    tooltip: {
                        sx: {
                            '& .MuiChartsTooltip-mark': {
                                width: '10px',
                                height: '10px',
                            },
                        },
                        trigger: 'item',
                    },
                }}
                series={series}
                height={50}
                hideLegend={true}
                sx={{
                    '.MuiChartsAxis-root': {
                        display: 'none',
                    },
                }}
                xAxis={[{ position: 'none' }]}
            />
            {/* Custom Legend Below the Chart */}
            <Stack display='flex' spacing={4} direction={'row'}>
                {labelSeries.map((item, index) => (
                    <Box key={index} display='flex' alignItems='center'>
                        <Box
                            sx={{
                                width: 16,
                                height: 16,
                                backgroundColor: item.color,
                                marginRight: 1,
                            }}
                        />
                        <Typography variant='body2'>
                            {item.label}: {formatPercentage(item.data, { locale, decimals: 1 })}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Box>
    )
}
